/*
Copyright (c) NAVER Corp.
name: @egjs/vue-grid
license: undefined
author: NAVER Corp.
repository: https://github.com/naver/egjs-grid/tree/main/packages/vue-grid
version: 1.14.2
*/
import { FrameGrid as FrameGrid$1, JustifiedGrid as JustifiedGrid$1, PackingGrid as PackingGrid$1, GRID_EVENTS, GRID_METHODS, MasonryGrid as MasonryGrid$1 } from '@egjs/grid';

function hForVue3(instance) {
  return function h(type, props, children) {
    var ref = null;

    if (props.ref) {
      ref = {
        i: instance.$,
        r: props.ref
      };
    }

    return {
      // https://github.com/vuejs/vue-next/blob/master/packages/shared/src/shapeFlags.ts
      // ELEMENT 1, ARRAY_CHILDREN 16
      shapeFlag: 17,
      type: type,
      props: props,
      ref: ref,
      children: children
    };
  };
}
/**
 * egjs-grid
 * Copyright (c) 2021-present NAVER Corp.
 * MIT license
 */


var Grid = {
  render: function (h1) {
    var h = typeof h1 === "function" ? h1 : hForVue3(this);
    var slots = this.$slots.default;
    var tag = this.$props.tag || "div";

    if (typeof slots === "function") {
      slots = slots();
    }

    return h(tag, {
      ref: "container"
    }, slots);
  }
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/** @deprecated */

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
}

var FrameGrid = makeGrid("frame-grid", FrameGrid$1, Grid);

var JustifiedGrid = makeGrid("justified-grid", JustifiedGrid$1, Grid);

var PackingGrid = makeGrid("packing-grid", PackingGrid$1, Grid);

function makeGrid(tagName, GridClass, VueComponent) {
  var propertyTypes = GridClass.propertyTypes,
      defaultOptions = GridClass.defaultOptions;
  var watch = {};

  var _loop_1 = function (name) {
    watch[name] = function (value) {
      this.$_grid[name] = value;
    };
  };

  for (var name in propertyTypes) {
    _loop_1(name);
  }

  var methods = {};
  GRID_METHODS.forEach(function (name) {
    methods[name] = function () {
      var _a;

      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return (_a = this.$_grid)[name].apply(_a, args);
    };
  });
  return __assign(__assign({}, VueComponent), {
    name: tagName,
    props: __spreadArrays(["tag"], Object.keys(defaultOptions)),
    watch: watch,
    methods: methods,
    mounted: function () {
      var _this = this;

      var options = {};
      var props = this.$props;

      for (var name in defaultOptions) {
        if (name in props && typeof props[name] !== "undefined") {
          options[name] = props[name];
        }
      }

      this.$_grid = new GridClass(this.$refs.container, options);
      this.$_grid.renderItems();
      GRID_EVENTS.forEach(function (name) {
        _this.$_grid.on(name, function (e) {
          _this.$emit(name, __assign({}, e));
        });
      });
    },
    beforeDestroy: function () {
      this.$_grid.destroy();
    },
    beforeUnmount: function () {
      this.$_grid.destroy();
    }
  });
}
function install(app) {
  app.component("masonry-grid", MasonryGrid);
  app.component("justified-grid", JustifiedGrid);
  app.component("frame-grid", FrameGrid);
  app.component("packing-grid", PackingGrid);
}

var MasonryGrid = makeGrid("masonry-grid", MasonryGrid$1, Grid);

export { FrameGrid, Grid, JustifiedGrid, MasonryGrid, PackingGrid, install, makeGrid };
//# sourceMappingURL=grid.esm.js.map
